import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { PatientsService } from '../patients.service';
import { PregnancyService } from '../pregnancy.service';
import { ExamsService } from '../exams.service';
import { Patient } from '../patients/patient';
import { LoginService } from '../login.service';
import { ExamsbarService } from './examsbar.service';

import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

// Exam nav (/exam); mode-aware: new card + es-tabs or the legacy panel + mainNav; talks to ExamComponent via ExamsbarService.
@Component({
  selector: 'app-exam-nav',
  templateUrl: './examsbar.component.html',
  styleUrls: ['./examsbar.component.scss'],
  standalone: false,
})
export class ExamNavComponent implements OnInit, OnDestroy {
  currentPage = 'Pregnancy';
  sub = new Subscription();
  isBookmark = false;
  surrogate: string;

  pat: Patient;
  constructor(
    public patservice: PatientsService,
    private pregServ: PregnancyService,
    public es: ExamsService,
    private router: Router,
    public ls: LoginService,
    private examsbarService: ExamsbarService,
    private host: ElementRef<HTMLElement>
  ) {}

  get newSidebar(): boolean {
    return this.ls.newSidebar;
  }

  ngOnInit() {
    this.pat = this.patservice.getPat();
    if (this.pat.ID == 'default') this.currentPage = 'Placenta';
    if (this.es.ExamType == 'Gynecology' || (this.ls.isCardio && !this.ls.isGastro))
      this.currentPage = 'Introduction';
    if (this.es.ExamType === 'Pediatric Echo') {
      this.currentPage = 'Anamnesis';
    }
    if (this.ls.isGastro) this.currentPage = 'Preparation';
    this.sub.add(
      this.es.NTAdd$.subscribe(() => {
        if (!this.es.addNT) this.setPage('Placenta');
      })
    );
    this.sub.add(
      this.examsbarService.switchPage$.subscribe((ex) => {
        this.currentPage = ex;
      })
    );
    this.sub.add(this.examsbarService.scrollNav$.subscribe((dir) => this.stepPage(dir)));
    this.examsbarService.neighbor = (dir) => this.neighbor(dir);
    if (this.ls.hasSurrogatePreg)
      this.patservice.getSurrogate(this.pat.PID, this.es.examID ? this.es.examID : null).subscribe(
        (data: any) => {
          this.surrogate = data['First'] + ' ' + data['Last'] + ' (' + data['ID'] + ')';
        },
        (error) => {
          console.log(error);
        }
      );
  }

  setPage(page: string) {
    this.es.ShowSRs = false;
    this.currentPage = page;
    this.examsbarService.pageChange$.next(page);
  }

  // Scroll navigation: the rendered tabs (data-page, in DOM order) are the source of truth,
  // so the visibility rules stay in the template only.
  private neighbor(dir: 'next' | 'prev'): { page: string; label: string } | null {
    const tabs = Array.from(this.host.nativeElement.querySelectorAll<HTMLElement>('[data-page]'));
    const idx = tabs.findIndex((el) => el.dataset['page'] === this.currentPage);
    if (idx === -1) return null;
    const el = tabs[dir === 'next' ? idx + 1 : idx - 1];
    return el ? { page: el.dataset['page'], label: el.textContent.trim() } : null;
  }

  private stepPage(dir: 'next' | 'prev') {
    const target = this.neighbor(dir);
    if (target) this.setPage(target.page);
  }

  showPatD() {
    this.examsbarService.showPatDetails$.next();
  }

  go(place: string) {
    this.router.navigateByUrl(place);
    this.es.exitExam();
  }

  bookmark() {
    console.log(this.es.examID);
    this.isBookmark = !this.isBookmark;
  }

  get ntWarning(): string | null {
    return (this.es.ExamType === 'NT' || this.es.ExamType === '1st') &&
      !this.patservice.getPat().Birth
      ? ('GUI.NT.CustomTooltips.Add Birth day by clicking here' as any)
      : null;
  }

  // Tab visibility + label logic, kept out of the template.
  get showBirthWarning(): boolean {
    return (
      !this.patservice.getPat().Birth && (this.es.ExamType === 'NT' || this.es.ExamType === '1st')
    );
  }

  get showObstetricTabs(): boolean {
    return (
      this.es.ExamType !== 'Gynecology' && !this.es.isForm && this.es.ExamType !== 'Emergency Room'
    );
  }

  get showAnatomyTab(): boolean {
    const t = this.es.ExamType;
    return (
      t !== 'Follicles' &&
      t !== 'CVS' &&
      t !== 'Amniocentesis' &&
      t !== 'NT' &&
      t !== '1st' &&
      t !== 'Followup' &&
      t !== 'Weight Assessment' &&
      t !== 'Tech Exam'
    );
  }

  get showObsDopplerTab(): boolean {
    const t = this.es.ExamType;
    return (
      t !== 'Follicles' &&
      t !== 'CVS' &&
      t !== 'Amniocentesis' &&
      t !== 'NT' &&
      t !== '1st' &&
      t !== 'Weight Assessment' &&
      t !== 'Fetal Echo' &&
      t !== 'Pediatric Echo'
    );
  }

  get showSummaryTab(): boolean {
    return !this.es.isForm && this.es.ExamType !== 'Emergency Room' && !this.ls.isGastro;
  }

  get ntTabLabel(): string {
    if (this.es.ExamType === 'NT') {
      return 'NT';
    }
    if (this.es.switchNT) {
      return '1ST & NT';
    }
    return this.es.addNT ? 'NT' : '1ST';
  }

  get measurementsTabKey(): string {
    const t = this.es.ExamType;
    if (t === 'Weight Assessment' || t === 'Tech Exam') {
      return 'GUI.Tabs.Fetal Growth';
    }
    if (t === 'Fetal Echo' || t === 'Pediatric Echo') {
      return 'GUI.Tabs.Measurements & Doppler';
    }
    return 'GUI.Tabs.Measurements';
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.examsbarService.neighbor = () => null;
  }
}
